var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 83,
    viewBox: "0 0 115 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16H30.5L43.5 0H71L84.5 16H114.5V82.5H0V16ZM80 47.5C80 59.9264 69.9264 70 57.5 70C45.0736 70 35 59.9264 35 47.5C35 35.0736 45.0736 25 57.5 25C69.9264 25 80 35.0736 80 47.5ZM85 47.5C85 62.6878 72.6878 75 57.5 75C42.3122 75 30 62.6878 30 47.5C30 32.3122 42.3122 20 57.5 20C72.6878 20 85 32.3122 85 47.5Z",
    fill: "#2B2A29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.5904e0e7c60ea546aa3f1dd2f4d68ac0.svg";
export { ForwardRef as ReactComponent };